<template>
  <div class="col-full">
    <div v-for="(link, index) in links" :key="`link-${index}`" class="row">
      <CardGrafana
        :iframeUrl="link.iframeUrl + optimisation + userId"
        :cardTitle="link.cardTitle"
      />
    </div>
  </div>
</template>

<script>
import CardGrafana from '@/components/CardGrafana';
import axios from 'axios';
import router from '@/router';

export default {
  components: {
    CardGrafana,
  },
  props: {
    links: {
      required: true,
      type: Array,
    },
  },
  computed: {
    userId() {
      return '&var-iduser=' + this.$store.state.userId;
    },
    dataSource() {
      return this.$store.state.dataSource;
    },
    optimisation() {
      if (this.$store.getters.optimId !== null) {
        return this.$store.getters.optimId;
      } else {
        return null;
      }
    },
  },
  mounted() {
    this.$store.dispatch('fetchUserInfos').then(() => {
      if (this.$store.state.userInfos.isViewer !== true) {
        if (
          this.$store.state.userInfos.email.length === 0 &&
          this.$route.path !== '/'
        ) {
          router.go();
          router.push('/');
        }
        if (this.$store.state.intro === true) {
          this.$tours['myTour'].start();
        }
        let self = this;
        const url =
          process.env.VUE_APP_BASE_URL + process.env.VUE_APP_OPTIMISATION;
        const user = this.$store.state.userInfos.email;
        axios({
          method: 'get',
          url: url,
          headers: {
            user: user,
          },
        }).then(response => {
          self.$store.dispatch('addOptimId', response.data);
        });
      }
    });
  },
};
</script>

<style lang="scss" scoped>
>>> .card .card-content {
  padding-bottom: 0;
}
.file {
  position: relative;
  overflow: hidden;
}
input {
  position: absolute;
  font-size: 3.125rem;
  opacity: 0;
  right: 0;
  top: 0;
}
.card-title {
  text-decoration: none;
  background-color: #f8a331 !important;
  text-align: center;
  letter-spacing: 0.03125rem;
  border: none;
  border-radius: 0.125rem;
  display: inline-block;
  height: 2.25rem;
  line-height: 2.25rem;
  padding: 0 1rem !important;
  text-transform: uppercase;
  font-size: 1rem;
}
.btn,
.btn-large,
.btn-small {
  background-color: #41c0bc !important;
}

</style>
